import { useEffect, useState } from "react";
import { Moon } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "../lib/api";

export const QuietHours = ({ base, dark = false }) => {
  const [q, setQ] = useState(null);
  useEffect(() => { http.get(`${base}/quiet-hours`).then((r) => setQ(r.data)).catch(() => {}); }, [base]);
  if (!q) return null;
  const save = async (v) => {
    const next = { ...q, ...v };
    setQ(next);
    try { await http.put(`${base}/quiet-hours`, next); toast.success(next.enabled ? `Heures de repos : alertes silencieuses de ${next.start} à ${next.end}` : "Heures de repos désactivées"); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const ipt = `rounded-md border px-1.5 py-1 text-xs ${dark ? "bg-white/10 border-white/20 text-white" : "border-slate-300 text-slate-800"}`;
  return (
    <div className={`rounded-md border px-3 py-2 space-y-1.5 ${dark ? "border-white/15" : "border-slate-200"}`} data-testid="quiet-hours">
      <label className={`flex items-center gap-2 text-xs font-semibold cursor-pointer ${dark ? "text-white" : "text-slate-800"}`}>
        <input type="checkbox" checked={q.enabled} onChange={(e) => save({ enabled: e.target.checked })} data-testid="quiet-enabled" />
        <Moon className="h-3.5 w-3.5" /> Heures de repos : alertes silencieuses
      </label>
      {q.enabled && (
        <div className={`flex items-center gap-1.5 text-xs ${dark ? "text-white/80" : "text-slate-600"}`}>
          de <input type="time" value={q.start} onChange={(e) => e.target.value && save({ start: e.target.value })} className={ipt} data-testid="quiet-start" />
          à <input type="time" value={q.end} onChange={(e) => e.target.value && save({ end: e.target.value })} className={ipt} data-testid="quiet-end" />
        </div>
      )}
      <p className={`text-[10px] ${dark ? "text-white/60" : "text-slate-500"}`}>Les alarmes PTI et les incidents urgents sonnent toujours.</p>
    </div>
  );
};
